module.exports = __webpack_public_path__ + "img/Webpack.7ac4d19b.svg";